exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg{background-color:#d3d3d3}[data-tag=P]{color:green}[data-tag=A]{color:red}[data-tag=L]{color:blue}[data-tag=H]{color:#00008b}.header{display:flex;align-items:center;margin-bottom:10px}.header img{width:100px;margin-right:20px}.header-text{flex:1;text-align:center}.report-wrapper{width:100%;overflow-x:auto}.report-table{width:100%;min-width:2200px;border-collapse:collapse;table-layout:auto}.report-table td,.report-table th{border:1px solid #dee2e6;padding:8px;font-size:12px;vertical-align:middle}.report-table th{text-align:center;white-space:normal;overflow-wrap:break-word;line-height:1.4}.report-table td{white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-719b08b1","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/ClientReportPrint.vue
// module id = 243
// module chunks = 0